var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import isEqual from 'lodash/isEqual';
import { memo, useMemo } from 'react';
import { useConversationHasMissingRequiredCustomFieldsInAcw } from 'utils/conversation';
/**
 * Represents a component for displaying the status color of a given
 * conversation. The component can be shaped through {@link Box} props.
 */
export const ConversationStatusColorBox = memo(function ConversationStatus(_a) {
    var { conversation } = _a, boxProps = __rest(_a, ["conversation"]);
    const { id: csid, status } = conversation;
    const isActive = status === 'open';
    const hasFollowUp = status === 'pending' || status === 'awaitingpending';
    const hasMissingRequiredCustomFieldsInAcw = useConversationHasMissingRequiredCustomFieldsInAcw({ csid });
    const background = useMemo(() => {
        if (hasMissingRequiredCustomFieldsInAcw) {
            return colors.orange[400];
        }
        if (isActive) {
            return colors.green[500];
        }
        if (hasFollowUp) {
            return colors.blue[400];
        }
        return colors.neutral[400];
    }, [hasFollowUp, hasMissingRequiredCustomFieldsInAcw, isActive]);
    return _jsx(Box, Object.assign({}, boxProps, { background: background }));
}, isEqual);
